import * as React from "react"
import { cn } from "../../lib/utils"

const Input = React.forwardRef(
  ({ className, type = "text", fieldName, readOnly, ...props }, ref) => {
    return (
      <input
        type={type}
        readOnly={readOnly}
        ref={ref}
        className={cn(
          "flex h-10 w-full rounded-md bg-background px-3 py-2 text-sm",
          "border border-gray-300",
          "read-only:bg-gray-300",
          "placeholder:text-muted-foreground",
          "focus:outline-none focus:ring-1 focus:ring-gray-800 focus:border-gray-900",
          "disabled:cursor-not-allowed disabled:opacity-50",
          `${fieldName === "prefix" && "uppercase"}`,
          className
        )}
        {...props}
      />
    );
  }
);


Input.displayName = "Input"

export { Input }
